<template>
  <v-dialog
    width="950"
    :value="dialogs.paymentFromTrial"
    :overlay-opacity="0.9"
    content-class="payment-dialog"
    :scrollable="false"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card
      class="payment-card"
      max-height="850"
      min-height="675"
    >
      <div class="payment-left-select-side" :style="{ overflowY: isOverflow()}">
        <!-- ЗАГАЛОВОК -->
        <div class="payment-from-trial-dialog-title payment-card-title">
          {{ $t('plans.paymentPlan') }}
          <span class="plan-name-text">
            {{ capitalizeText(paymentInfo.plan) }}
          </span>
        </div>

        <div class="payment-info-wrapper">
          <div class="d-flex align-center justify-space-around">
            <!-- АККАУНТ -->
            <div class="payment-info-account flex-grow-1">
              <div class="payment-info-title-text">
                {{ $t('common.account') }}
              </div>
              <div class="payment-info-value-text">
                {{ profile.username }}
              </div>
            </div>

            <!-- ПРОФИЛЕЙ В ТАРИФЕ -->
            <div class="payment-info-top-profiles-count flex-grow-1">
              <div class="payment-info-title-text">
                {{ $t('plans.profilesInTariff') }}
              </div>
              <div class="payment-info-value-text">
                {{ paymentInfo.profilesCount }}
              </div>
            </div>
          </div>

          <!-- КОЛИЧЕСТВО ПРОФИЛЕЙ -->
          <payment-dialog-profiles-count />

          <!-- ДОПОЛНИТЕЛЬНЫЕ ПОЛЬЗОВАТЕЛИ -->
          <payment-dialog-extra-users />

          <!-- ПЕРИОД ОПЛАТЫ -->
          <payment-dialog-prolong-months />

          <!-- СПОСОБ ОПЛАТЫ -->
          <payment-dialog-payment-methods v-if="showPaymentMethods" ref="paymentMethods" :estimate="estimate" />

          <!-- ВЫВОД ОШИБОК -->
          <v-alert
            v-if="error.show"
            color="error"
            text
            class="mb-0 mt-4 mb-4"
          >
            {{ error.message }}
          </v-alert>

          <!-- ИНФОРМАЦИЯ О КОМПАНИИ -->
          <payment-dialog-company-info
            v-if="showPaymentDialogCompanyInfo"
          />
        </div>
      </div>

      <!-- К ОПЛАТЕ -->
      <payment-dialog-summary
        :estimate="estimate"
        :pay="pay"
        :handle-promo-apply="handlePromoApply"
        :pay-loading="payLoading"
        :promocode-loading="promocodeLoading"
      />

      <!-- КНОПКА ЗАКРЫТЬ -->
      <div
        class="payment-close-button"
        @click="closeDialog"
      >
        <v-icon
          :size="18"
          color="gray"
        >
          mdi-close
        </v-icon>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters } from "vuex";
  import { mapFields } from "vuex-map-fields";
  import { capitalizeText } from "@/utils/helpers";
  import calculationsMixin from "@/mixins/calculations";
  import paymentMixin from "@/mixins/payment"
  import PaymentDialogProfilesCount from "@/components/plans/dialogs/components/PaymentDialogProfilesCount";
  import PaymentDialogExtraUsers from "@/components/plans/dialogs/components/PaymentDialogExtraUsers";
  import PaymentDialogProlongMonths from "@/components/plans/dialogs/components/PaymentDialogProlongMonths";
  import PaymentDialogPaymentMethods from "@/components/plans/dialogs/components/paymentMethods/PaymentDialogPaymentMethods";
  import PaymentDialogSummary from "@/components/plans/dialogs/components/PaymentDialogSummary";
  import PaymentDialogCompanyInfo from "@/components/plans/dialogs/components/PaymentDialogCompanyInfo";
  import {
    PAYMENT_METHOD_CAPITALIST_NAME,
    PAYMENT_METHOD_CARD_NAME,
    PAYMENT_METHOD_CRYPTO_NAME,
    PAYMENT_METHOD_CLOUDPAYMENTS_NAME,
    PAYMENT_METHOD_CRYPTOMUS_NAME,
    PAYMENT_METHOD_FREEKASSA_NAME,
    PAYMENT_METHOD_INXY_NAME,
    PAYMENT_METHOD_UNLIMINT_NAME,
    PAYMENT_METHOD_USDT_NAME,
    PAYMENT_METHOD_WALLET_NAME,
    PAYMENT_METHOD_STRIPE
  } from '@/constants/plans'

  export default {
    name: 'PaymentFromTrialDialog',

    components: {
      PaymentDialogProfilesCount,
      PaymentDialogExtraUsers,
      PaymentDialogProlongMonths,
      PaymentDialogPaymentMethods,
      PaymentDialogSummary,
      PaymentDialogCompanyInfo
    },

    mixins: [
      calculationsMixin,
      paymentMixin
    ],

    data () {
      return {
        estimate: 0,
        error: {
          show: true,
          message: 'error'
        },
        payLoading: false,
        promocodeLoading: false,
        capitalistInterval: 0,
        unlimintInterval: 0,
        cryptoInterval: 0,
        usdtInterval: 0,
        PAYMENT_METHOD_CARD_NAME,
        PAYMENT_METHOD_UNLIMINT_NAME,
        PAYMENT_METHOD_STRIPE
      }
    },

    computed: {
      ...mapGetters({
        dialogs: 'plans/dialogs',
        paymentInfo: 'plans/paymentInfo',
        profile: 'main/profile',
        countryCode: 'plans/countryCode',
        isLocalCard: 'plans/isLocalCard',
        promocodeState: 'plans/promocodeState',
        paymentSummary: 'plans/paymentSummary',
        balance: 'plans/balance',
        dontShowPaymentLeftSideScroll: 'plans/dontShowPaymentLeftSideScroll',
      }),
      ...mapFields('main', ['queryParamPromo']),
      ...mapFields('plans', ['invoice']),

      showPaymentMethods () {
        return this.paymentSummary.total > 0
      }
    },

    watch: {
      countryCode: {
        deep: true,

        async handler () {
          await this.$store.dispatch('plans/setIsLocalCard', this.countryCode === "RU")
        }
      }
    },

    async created () {
      this.$set(this.error, 'show', false)
      this.$set(this.error, 'message', '')

      if (this.queryParamPromo) {
        this.$store.dispatch('plans/updatePaymentInfo', {
          promocode: this.queryParamPromo
        })

        this.handlePromoApply(this.queryParamPromo)
      }
    },

    async mounted () {
      await this.$store.dispatch('plans/setIsLocalCard', this.countryCode === "RU")
    },

    async beforeDestroy () {
      if (this.cryptoInterval) {
        clearInterval(this.cryptoInterval)
      }

      if (this.usdtInterval) {
        clearInterval(this.usdtInterval)
      }

      if (this.capitalistInterval) {
        clearInterval(this.capitalistInterval)
      }

      await this.$store.dispatch('plans/clearInvoice')
      await this.$store.dispatch('plans/clearPromo')
      await this.$store.dispatch('plans/reloadPaymentInfo')
    },

    methods: {
      capitalizeText,

      isOverflow() {
        return this.dontShowPaymentLeftSideScroll && !this.showPaymentMethods ? 'unset' : 'auto';
      },

      closeDialog () {
        this.$store.dispatch('plans/closeDialog', 'paymentFromTrial')
      },

      async pay () {
        try {
          this.payLoading = true

          await this.$store.dispatch('plans/clearPromo')

          this.$set(this.error, 'show', false)
          this.$set(this.error, 'message', '')

          const invoiceResponse = await this.$store.dispatch('plans/createPaymentInvoice')

          if (
            invoiceResponse &&
            invoiceResponse.status === 200 &&
            invoiceResponse.data?.data &&
            invoiceResponse.data.data.invoiceId &&
            invoiceResponse.data.data.currency &&
            invoiceResponse.data.data.provider
          ) {
            try {
              this.$metrika.reachGoal('payment')
            } catch (e) {
              console.error(e)
            }
            this.successfulPaymentAlert = false

            switch (this.paymentInfo.paymentMethod) {
              case PAYMENT_METHOD_CARD_NAME:
                if (invoiceResponse.data.data.provider === PAYMENT_METHOD_CLOUDPAYMENTS_NAME) {
                  const { invoiceId, sum, currency } = invoiceResponse.data.data;

                  this.openCloudPaymentsWidget(
                    invoiceId.toString(),
                    sum,
                    currency,
                    this.closeDialog
                  )
                } else if (invoiceResponse.data.data.provider === PAYMENT_METHOD_FREEKASSA_NAME) {
                  const { freeKassaPaymentUrl } = invoiceResponse.data.data
                  window.open(freeKassaPaymentUrl, '_blank')
                }
                break;
              case PAYMENT_METHOD_UNLIMINT_NAME:
                window.open(invoiceResponse.data.data.unlimintPaymentUrl,'_self');
                this.unlimintInterval = this.setPaymentInterval(this.unlimintInterval, invoiceResponse.data.data.invoiceId, this.closeDialog)
                break;
              case PAYMENT_METHOD_STRIPE:
                window.open(invoiceResponse.data.data.stripePaymentUrl,'_blank');
                break;
              case PAYMENT_METHOD_CRYPTO_NAME:
                if (invoiceResponse.data.data.provider === PAYMENT_METHOD_CRYPTOMUS_NAME) {
                  window.open(invoiceResponse.data.data.cryptomusPaymentUrl, '_blank');
                } else if (invoiceResponse.data.data.provider === PAYMENT_METHOD_INXY_NAME) {
                  window.open(invoiceResponse.data.data.inxyPaymentUrl, '_blank');
                }
                break;
              case PAYMENT_METHOD_CAPITALIST_NAME:
                this.capitalistInterval = this.setPaymentInterval(this.capitalistInterval, invoiceResponse.data.data.invoiceId, this.closeDialog)
                await this.$nextTick()
                this.$refs.paymentMethods.$refs.capitalist.submit()
                break;
              case PAYMENT_METHOD_USDT_NAME:
                if (invoiceResponse.data.data.provider === PAYMENT_METHOD_CRYPTOMUS_NAME) {
                  window.open(invoiceResponse.data.data.cryptomusPaymentUrl,'_blank');
                  this.usdtInterval = this.setPaymentInterval(this.usdtInterval, invoiceResponse.data.data.invoiceId, this.closeDialog)
                } else if (invoiceResponse.data.data.provider === PAYMENT_METHOD_INXY_NAME) {
                  window.open(invoiceResponse.data.data.inxyPaymentUrl, '_blank');
                }
                break;
              case PAYMENT_METHOD_WALLET_NAME:
                if (invoiceResponse.data.data.provider === PAYMENT_METHOD_CAPITALIST_NAME) {
                  this.capitalistInterval = this.setPaymentInterval(this.capitalistInterval, invoiceResponse.data.data.invoiceId, this.closeDialog)
                  await this.$nextTick()
                  this.$refs.paymentMethods.$refs.capitalist.submit()

                  break;
                } else {
                  this.$refs.paymentMethods.$refs.paymentTarget.action = invoiceResponse.data.data.unlimintPaymentUrl;
                  this.$refs.paymentMethods.$refs.paymentTarget.submit();
                  this.unlimintInterval = this.setPaymentInterval(this.unlimintInterval, invoiceResponse.data.data.invoiceId, this.closeDialog)

                  break;
                }
            }
          } else {
            console.log(invoiceResponse, 'Invoice response')
          }
        } catch (e) {
          const error = e.response

          if (error.status === 500) {
            this.$set(this.error, 'show', true)
            this.$set(this.error, 'message', this.$t('plans.errors.somethingWentWrong'))
          } else if (error.data && error.data.error && error.data.error.code) {
            this.$set(this.error, 'show', true)

            if (error.data.error.text === 'This promo is not valid') {
              this.$set(this.error, 'message', this.$t(`plans.errors.E_INVALID_PROMO`))
              this.promocodeState.status = 'error'
            } else {
              this.$set(this.error, 'message', this.$t(`plans.errors.${error.data.error.code}`))
            }
          }
        } finally {
          this.payLoading = false
        }
      },

      async handlePromoApply (value) {
        this.paymentInfo.promocode = value
        this.promocodeLoading = true

        try {
          const response = await this.$store.dispatch('plans/checkPromocode', value)

          if (response.status === 200 && response.data?.data) {
            const { data } = response.data

            const promocodeState = {
              status: 'success',
              discount: data.discount,
              errorText: ''
            }

            if (data.discount === 0) {
              promocodeState.status = 'error'

              if (data.discount === 0 && this.profile.team.usedPromo) {
                promocodeState.errorText = 'promoForFirstPayment'
              } else {
                promocodeState.errorText = 'promoLimitExceed'
              }
            }

            await this.$store.dispatch('plans/setPromocodeState', promocodeState)
          } else {
            await this.$store.dispatch('plans/setPromocodeState', {
              status: 'error',
              discount: 0,
              errorText: ''
            })
          }
        } catch (e) {
          await this.$store.dispatch('plans/setPromocodeState', {
            status: 'error',
            discount: 0,
            errorText: ''
          })
        } finally {
          this.promocodeLoading = false
        }
      }
    }
  }
</script>

<style>
  .payment-dialog {
    border-radius: 20px;
    max-height: 850px;
    overflow-y: unset;
  }

  .plan-name-text {
    color: #B547E9;
  }

  .payment-from-trial-dialog-title {
    font-weight: 500!important;
    font-size: 24px!important;
    line-height: 120%;
  }

  .payment-left-select-side {
    flex: 1;
    max-width: 670px;
    padding: 20px 32px 30px 32px!important;
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb {
    background: #ADADAD;
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #959595;
  }

  .payment-card {
    border-radius: 20px!important;
    display: flex;
    justify-content: space-between;
    position: relative;
    min-height: 500px;
    max-height: calc(100vh - 100px)!important;
  }

  .payment-info-wrapper {
    margin-top: 24px;
  }

  .payment-info-title-text {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: flex-end;
    font-feature-settings: 'tnum' on, 'lnum' on;
    color: #555E71;
  }

  .payment-info-value-text {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: flex-end;
    font-feature-settings: 'tnum' on, 'lnum' on;
    color: #414452;
    margin-top: 8px;
  }

  .payment-info-input {
    width: 100%;
    border-radius: 50px;
    outline: unset;
    font-size: 14px;
    padding: 6px 12px 6px 16px;
    border: 1px solid #939393;
  }

  .payment-close-button {
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;
  }
</style>
